

import React, { useState } from "react";
import andres from "../img/4.jpg";
import aldo from "../img/1.jpg";
import diego from "../img/5.jpg";
import pamela from "../img/2.jpg";
import Katherina from "../img/3.jpg";
import "../App.css";

function EquipoGestion() {
  const equipo = [
    { nombre: 'Andres Tapia Torres', cargo: 'Director(a)', imagen: andres },
    { nombre: 'Aldo Alberto Bustamante', cargo: 'Inspector General', imagen: aldo },
    { nombre: 'Diego Pozo Cabello', cargo: 'UTP', imagen: diego },
    { nombre: 'Pamela Contreras Pérez', cargo: 'Convivencia Escolar', imagen: pamela },
    { nombre: 'Katherina Paz Cifuentes', cargo: 'Coordinadora P.I.E.', imagen: Katherina },
  ];

  // Estado para imagen ampliada
  const [imagenGrande, setImagenGrande] = useState(null);

  return (
    <section id="equipo-gestion" className="equipo-section">

      {/* Quiénes Somos */}
      <div className="transparente-card texto-section">
        <h2 className="titulo-transparente">Quiénes Somos</h2>
        <p className="quienes-somos-texto">
          Somos una escuela pública, de educación Parvularia y Básica, fundada en 1965 en el marco de la reforma educativa. 
          En la actualidad depende de la administración comunal de la Municipalidad de Independencia.
        </p>
      </div>

      {/* Equipo de Gestión */}
      <div className="transparente-card">
        <h2 className="titulo-transparente">Equipo de Gestión</h2>
        <p className="descripcion">
          ¡Conoce a nuestro Equipo directivo!
        </p>
        <div className="tarjetas">
          {equipo.map((miembro, index) => (
            <div className="tarjeta" key={index}>
              <img
                src={miembro.imagen}
                alt={miembro.nombre}
                onDoubleClick={() => setImagenGrande(miembro.imagen)}
                style={{ cursor: 'pointer' }}
              />
              <h3>{miembro.nombre}</h3>
              <p>{miembro.cargo}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Modal para imagen grande */}
      {imagenGrande && (
        <div className="modal-imagen" onClick={() => setImagenGrande(null)}>
          <img src={imagenGrande} alt="Ampliada" />
        </div>
      )}

    </section>
  );
}

export default EquipoGestion;
